import React from 'react';
import { Check, Map, User, Lightbulb, TrendingUp } from 'lucide-react';
import { Button } from './ui/Button';
export function BenefitsSection() {
  return <section className="bg-[#FDF6E3] py-16 px-4 sm:px-6 lg:px-8" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        {/* Impact Stats */}
        <div className="text-center mb-12" data-id="element-3">
          <h2 className="text-2xl md:text-3xl font-bold text-[#1e3a5a] mb-8" data-id="element-4">
            El impacto es concreto
          </h2>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-5">
            <div className="bg-white p-5 rounded-xl shadow-sm border border-[#d4a853]/20 text-center" data-id="element-6">
              <div className="text-3xl font-black text-[#d4a853] mb-1" data-id="element-7">
                -70%
              </div>
              <p className="text-sm text-gray-600" data-id="element-8">Horas planificando</p>
            </div>
            <div className="bg-white p-5 rounded-xl shadow-sm border border-[#d4a853]/20 text-center" data-id="element-9">
              <div className="text-3xl font-black text-[#d4a853] mb-1" data-id="element-10">
                +100%
              </div>
              <p className="text-sm text-gray-600" data-id="element-11">Seguridad en clase</p>
            </div>
            <div className="bg-white p-5 rounded-xl shadow-sm border border-[#d4a853]/20 text-center" data-id="element-12">
              <div className="text-3xl font-black text-[#d4a853] mb-1" data-id="element-13">
                +80%
              </div>
              <p className="text-sm text-gray-600" data-id="element-14">Participación</p>
            </div>
            <div className="bg-white p-5 rounded-xl shadow-sm border border-[#d4a853]/20 text-center" data-id="element-15">
              <div className="text-3xl font-black text-[#d4a853] mb-1" data-id="element-16">
                100%
              </div>
              <p className="text-sm text-gray-600" data-id="element-17">Año organizado</p>
            </div>
          </div>
        </div>

        {/* Metaphors - More Visual */}
        <div className="grid md:grid-cols-3 gap-6 mb-12" data-id="element-18">
          <div className="bg-white p-6 rounded-xl shadow-sm text-center transform transition hover:scale-105 hover:shadow-lg cursor-pointer" onClick={() => document.getElementById('comprar')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-19">
            <div className="bg-[#1e3a5a] w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-20">
              <Map className="w-7 h-7 text-[#d4a853]" data-id="element-21" />
            </div>
            <h3 className="font-bold text-[#1e3a5a] mb-2" data-id="element-22">GPS Docente</h3>
            <p className="text-sm text-gray-600" data-id="element-23">
              Sabés exactamente a dónde ir clase por clase
            </p>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-sm text-center transform transition hover:scale-105 hover:shadow-lg cursor-pointer" onClick={() => document.getElementById('comprar')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-24">
            <div className="bg-[#1e3a5a] w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-25">
              <User className="w-7 h-7 text-[#d4a853]" data-id="element-26" />
            </div>
            <h3 className="font-bold text-[#1e3a5a] mb-2" data-id="element-27">
              Asistente Invisible
            </h3>
            <p className="text-sm text-gray-600" data-id="element-28">
              Planifica por vos. Vos solo enseñás
            </p>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-sm text-center transform transition hover:scale-105 hover:shadow-lg cursor-pointer" onClick={() => document.getElementById('comprar')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-29">
            <div className="bg-[#1e3a5a] w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-30">
              <Lightbulb className="w-7 h-7 text-[#d4a853]" data-id="element-31" />
            </div>
            <h3 className="font-bold text-[#1e3a5a] mb-2" data-id="element-32">Claridad Total</h3>
            <p className="text-sm text-gray-600" data-id="element-33">
              De ver poco a ver todo claro
            </p>
          </div>
        </div>

        {/* Promise Box */}
        <div className="bg-[#1e3a5a] rounded-2xl p-8 shadow-xl text-white text-center mb-12" data-id="element-34">
          <h3 className="text-xl md:text-2xl font-bold mb-4" data-id="element-35">
            No es magia. Es <span className="text-[#d4a853]" data-id="element-36">algo mejor.</span>
          </h3>
          <div className="flex flex-wrap justify-center gap-3 mb-6" data-id="element-37">
            <span className="bg-[#d4a853] text-[#1e3a5a] px-5 py-2 rounded-full font-bold text-sm" data-id="element-38">
              ✓ Orden
            </span>
            <span className="bg-[#d4a853] text-[#1e3a5a] px-5 py-2 rounded-full font-bold text-sm" data-id="element-39">
              ✓ Claridad
            </span>
            <span className="bg-[#d4a853] text-[#1e3a5a] px-5 py-2 rounded-full font-bold text-sm" data-id="element-40">
              ✓ Clases que funcionan
            </span>
          </div>
          <p className="text-blue-100 text-sm" data-id="element-41">
            Te da seguridad • Te devuelve tiempo • Mejora el clima del aula
          </p>
        </div>

        {/* Final CTA */}
        <div className="bg-white rounded-2xl p-8 shadow-lg border border-[#d4a853]/20 text-center" data-id="element-42">
          <h3 className="text-xl font-bold text-[#1e3a5a] mb-4" data-id="element-43">
            ¿Sentís que la clase no fluye?
          </h3>
          <p className="text-gray-600 mb-6" data-id="element-44">
            No es porque no seas buen docente. Es porque nadie te dio un sistema
            pensado para secundaria.{' '}
            <span className="text-[#d4a853] font-bold" data-id="element-45">Hasta ahora.</span>
          </p>
          <Button className="text-lg px-8 py-4" data-id="element-46">
            QUIERO ORGANIZAR MI AÑO AHORA
          </Button>
        </div>
      </div>
    </section>;
}